export default __webpack_public_path__ + "static/media/viber.aa88c16e.svg";